import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TeacherLessonListVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const retrieveLessons = createAsyncThunk<TeacherLessonListVM[], void, { extra: Partial<Dependencies> }>(
  "lessons/retrieveLessons",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.allLessons();
  },
);
